var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 57,
    viewBox: "0 0 70 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.333 12C15.333 8.68629 18.0193 6 21.333 6C24.6467 6 27.333 8.68629 27.333 12C27.333 15.3137 24.6467 18 21.333 18C18.0193 18 15.333 15.3137 15.333 12ZM21.333 0C14.7056 0 9.33301 5.37258 9.33301 12C9.33301 18.6274 14.7056 24 21.333 24C27.9604 24 33.333 18.6274 33.333 12C33.333 5.37258 27.9604 0 21.333 0ZM45.333 19.5C45.333 17.0147 47.3477 15 49.833 15C52.3183 15 54.333 17.0147 54.333 19.5C54.333 21.9853 52.3183 24 49.833 24C47.3477 24 45.333 21.9853 45.333 19.5ZM49.833 9C44.034 9 39.333 13.701 39.333 19.5C39.333 25.299 44.034 30 49.833 30C55.632 30 60.333 25.299 60.333 19.5C60.333 13.701 55.632 9 49.833 9ZM21.333 33C13.0487 33 6.33301 39.7158 6.33301 48V51H36.333V48C36.333 39.7158 29.6173 33 21.333 33ZM0.333008 48C0.333008 36.4021 9.73502 27 21.333 27C28.6402 27 35.0756 30.7321 38.8373 36.3942C41.9669 34.254 45.7549 33 49.8331 33C60.6028 33 69.3331 41.7303 69.3331 52.5V54V57H66.3331H42.333H40.4044H39.3331H39.333H36.3331H3.33301H0.333008V54V48ZM42.3331 51V48C42.3331 47.6172 42.3228 47.2368 42.3025 46.8588C42.2111 45.152 41.9159 43.4993 41.4408 41.9246C43.7464 40.0916 46.6604 39 49.8331 39C56.782 39 62.5045 44.25 63.2507 51H42.3331Z",
    fill: "#2DC8C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.333 12C15.333 8.68629 18.0193 6 21.333 6C24.6467 6 27.333 8.68629 27.333 12C27.333 15.3137 24.6467 18 21.333 18C18.0193 18 15.333 15.3137 15.333 12ZM21.333 0C14.7056 0 9.33301 5.37258 9.33301 12C9.33301 18.6274 14.7056 24 21.333 24C27.9604 24 33.333 18.6274 33.333 12C33.333 5.37258 27.9604 0 21.333 0ZM45.333 19.5C45.333 17.0147 47.3477 15 49.833 15C52.3183 15 54.333 17.0147 54.333 19.5C54.333 21.9853 52.3183 24 49.833 24C47.3477 24 45.333 21.9853 45.333 19.5ZM49.833 9C44.034 9 39.333 13.701 39.333 19.5C39.333 25.299 44.034 30 49.833 30C55.632 30 60.333 25.299 60.333 19.5C60.333 13.701 55.632 9 49.833 9ZM21.333 33C13.0487 33 6.33301 39.7158 6.33301 48V51H36.333V48C36.333 39.7158 29.6173 33 21.333 33ZM0.333008 48C0.333008 36.4021 9.73502 27 21.333 27C28.6402 27 35.0756 30.7321 38.8373 36.3942C41.9669 34.254 45.7549 33 49.8331 33C60.6028 33 69.3331 41.7303 69.3331 52.5V54V57H66.3331H42.333H40.4044H39.3331H39.333H36.3331H3.33301H0.333008V54V48ZM42.3331 51V48C42.3331 47.6172 42.3228 47.2368 42.3025 46.8588C42.2111 45.152 41.9159 43.4993 41.4408 41.9246C43.7464 40.0916 46.6604 39 49.8331 39C56.782 39 62.5045 44.25 63.2507 51H42.3331Z",
    fill: "url(#paint0_linear_272_2932)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_272_2932",
    x1: 54.1178,
    y1: -79.2072,
    x2: -52.0603,
    y2: 25.0168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.206376,
    stopColor: "#FFF0A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359714,
    stopColor: "#FFD700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833386,
    stopColor: "#FF41F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF33FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoPeople);
export default __webpack_public_path__ + "static/media/two-people.0c11cc81c41ba512bf2938e345028004.svg";
export { ForwardRef as ReactComponent };